import samplingCertificates from './Config/index';

export default {
  ...samplingCertificates,
};
